/* assets/consent-preferences.js
 * Two-layer cookie consent banner: Accept / More options, with a
 * per-category preference panel (Save preferences, no reject-all).
 * Uses Shopify's native Consent Tracking API directly, independent
 * of the theme's bundled <consent-tracking> element.
 */
class ConsentPreferences extends HTMLElement {
  connectedCallback() {
    this.accept = this.querySelector('.popup--block--accept');
    this.moreOptions = this.querySelector('.popup--block--more-options');
    this.savePreferences = this.querySelector('.popup--block--save-preferences');
    this.checkboxes = this.querySelectorAll('.popup--consent--checkbox');
    this.limit = this.parentNode && this.parentNode.getAttribute('data-limit') === 'true';
    this.addListeners();

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: () => {
          if (!window.Shopify.customerPrivacy) return;
          const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
          const unset = consent.marketing === '' && consent.analytics === '' && consent.preferences === '';
          if (window.Shopify.customerPrivacy.shouldShowBanner() && unset && !window.Shopify.designMode) {
            this.open();
          }
        }
      }]);
    }
  }

  addListeners() {
    if (this.accept) {
      this.accept.addEventListener('click', () => {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: true, marketing: true, preferences: true },
          () => this.close()
        );
      });
    }

    if (this.moreOptions) {
      this.moreOptions.addEventListener('click', () => {
        this.setAttribute('data-options-open', 'true');
      });
    }

    if (this.savePreferences) {
      this.savePreferences.addEventListener('click', () => {
        const consent = { analytics: false, marketing: false, preferences: false };
        this.checkboxes.forEach((box) => { consent[box.value] = box.checked; });
        window.Shopify.customerPrivacy.setTrackingConsent(consent, () => this.close());
      });
    }

    if (window.Shopify && window.Shopify.designMode) {
      this.addEventListener('theme:block:deselect', () => this.close());
      this.addEventListener('theme:block:select', () => {
        this.removeAttribute('data-options-open');
        this.open();
      });
    }
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => this.setAttribute('aria-expanded', 'true'));
  }

  close() {
    this.setAttribute('aria-expanded', 'false');
    this.addEventListener('transitionend', () => {
      this.setAttribute('aria-hidden', 'true');
      this.removeAttribute('data-options-open');
    }, { once: true });
  }
}

customElements.get('consent-preferences') || customElements.define('consent-preferences', ConsentPreferences);
